<mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
<table mat-table matSort [dataSource]="provider$" (matSortChange)="changeSort($event)">
  <ng-container [matColumnDef]="'colunaCheckbox'">
    <th
      mat-header-cell
      [style.justifyContent]="'center'"
      [style.text-align]="'center'"
      [style.width]="'120px'"
      *matHeaderCellDef
    >
      <mat-checkbox
        [(ngModel)]="checkBoxHeader"
        (change)="checkboxChangeAll($event)"
      ></mat-checkbox>
    </th>
    <td
      mat-cell
      [style.justifyContent]="'center'"
      [style.text-align]="'center'"
      *matCellDef="let row"
      [style.width]="'120px'"
    >
      <mat-checkbox
        [(ngModel)]="row.checkboxSelecao"
        (change)="checkboxChange(row)"
      ></mat-checkbox>
    </td>
  </ng-container>
  <ng-container [matColumnDef]="'colunaSelecao'">
    <th
      mat-header-cell
      [style.justifyContent]="'center'"
      [style.text-align]="'center'"
      [style.width]="'120px'"
      *matHeaderCellDef
    >
      <span> # </span>
    </th>
    <td
      mat-cell
      [style.justifyContent]="'center'"
      [style.text-align]="'center'"
      *matCellDef="let row"
      [style.width]="'120px'"
    >
      <button mat-button (click)="selecinouItem(row)">
        <em class="la la-check"></em>
      </button>
    </td>
  </ng-container>
  <ng-container
    *ngFor="let column of listaColunas; let i = index"
    [matColumnDef]="column.nameColumn"
  >
    <th
      mat-header-cell
      *matHeaderCellDef
      [mat-sort-header]="column.sortName"
      [disabled]="column.sortName == null || column.sortName == undefined || column.sortName == ''"
      [style.justifyContent]="column.cellAlign"
      [style.text-align]="column.cellAlign"
      [style.min-width]="column.widthColumn"
      [style.max-width]="column.maxWidthColumn"
    >
      <span> {{ column.nameHeader }}</span>
    </th>
    <td
      mat-cell
      *matCellDef="let element"
      (click)="selectedItem = $event"
      [style.justifyContent]="column.cellAlign"
      [style.textAlign]="column.cellAlign"
      [style.min-width]="column.widthColumn"
      [style.max-width]="column.maxWidthColumn || column.widthColumn"
    >
      <span *ngIf="!column.isIcone && column.nameColumn !== 'cor'" >{{
        column.valor ? column.valor(element) : element[column.nameColumn]
        }}</span>
      <span *ngIf="!column.isIcone && column.valorInner && column.nameColumn !== 'cor'" [innerHtml]='column.valorInner(element)'>  </span>
      <div
        *ngIf="column.nameColumn === 'cor' && element.cor"
        class="div-color-picker"
        [style.background]="element.cor">
      </div>
      <mat-icon
        [style.color]="column.style ? column.style(element) : null"
        *ngIf="column.isIcone"
        [matTooltip]="column.columnTooltipIcone(element)"
      >
        {{ column.icone(element) }}</mat-icon
      >
      <button
        class="botao-acao-grid"
        (click)="column.acao.evento(element); $event.stopPropagation(); selected = [element]"
        *ngIf="column.acao && column.acao.visivel ? column.acao.visivel(element) : false"
        [disabled]="column.acao && column.acao.disabled ? column.acao.disabled(element) : false">
        <strong
          [matTooltip]="column.acao?.toolTip(element)"
          [matTooltipDisabled]="false"
        >
              <span
                *ngIf="column.acao && column.acao.icone"
                [class]="column.acao.icone(element)"
                [style.color]="column.acao.style ? column.acao.style(element) : null"
                [style.font-size]="'small'"
              >
              </span>
          <mat-icon
            *ngIf="column.acao && column.acao.iconMat"
            [style.color]="column.acao.style ? column.acao.style(element) : null"
            [style.font-size]="'large'"
            [style.margin-top]="'9px'"
          >{{ column.acao.iconMat ? column.acao.iconMat(element) : null }}
          </mat-icon>
        </strong>
      </button>
    </td>
  </ng-container>

  <ng-container *ngIf="acoes?.length > 0" [matColumnDef]="'colunaAcoes'">
    <th mat-header-cell *matHeaderCellDef class="acoes">
      <span> Ações </span>
    </th>

    <td
      mat-cell
      *matCellDef="let row"
      class="acoes"
      [style.width]="widthColunaAcoes"
    >
      <div class="coluna-acao">
        <ng-container *ngFor="let acao of acoes">
          <div [matTooltip]="acao.toolTip(row)"
               [matTooltipDisabled]="false">
            <button
              class="botao-acao-grid"
              (click)="acao.evento(row); $event.stopPropagation(); selected = [row]"
              *ngIf="acao.visivel ? acao.visivel(row) : true"
              [disabled]="acao.disabled ? acao.disabled(row) : false">
              <strong>
              <span
                *ngIf="acao.icone"
                [class]="acao.icone(row)"
                [style.color]="acao.style ? acao.style(row) : null"
                [style.font-size]="'large'"
              >
              </span>
                <mat-icon
                  *ngIf="acao.iconMat"
                  [style.color]="acao.style ? acao.style(row) : null"
                  [style.font-size]="'large'"
                  [style.margin-top]="'9px'"
                >{{ acao.iconMat ? acao.iconMat(row) : null }}
                </mat-icon>
              </strong>
              <img
                *ngIf="acao.imgIcon"
                [src]="acao.imgIcon(row)"
                [style.width.px]="21"
                [style.height.px]="21"
              />
            </button>
          </div>
        </ng-container>
      </div>
    </td>
  </ng-container>

  <tbody>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr
    mat-row
    (dblclick)="selecinouItem(row)"
    *matRowDef="let row; columns: displayedColumns"
    [ngClass]="[row === selectedItem ? 'mat-row-selected' : '', getRowClass(row)]"
  ></tr>
  </tbody>
</table>
<mat-paginator
  #matPaginator
  *ngIf="interUtilizaPaginacao"
  showFirstLastButtons
  [disabled]="isLoading"
  [pageIndex]="indicePagina"
  [pageSize]="10"
  [length]="paginator$"
  (page)="changePage($event)"
  [pageSizeOptions]="[5, 10, 25, 100]"
  aria-label="Select page"
>
  >
</mat-paginator>
